import React, { useEffect, useState } from 'react'
import { Col, Empty, Row, Timeline } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import { selectLogsEvent, selectLogs } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { LogsData, LogsReq } from 'Store/orders/types'
import { getOrderLogsAPI } from 'Store/orders/api'
import { LoadingView } from 'Components/modal'
import { formatDateTime, formatStatusPayment } from 'helpers/format'
import { MyTheme } from 'Components/common/Theme'
import { logsCreditTermStatus, logsOrderStatus } from 'helpers/constanst'
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import LinkText from 'Components/text/LinkText'

type Props = {
  isShow: boolean
  onClose: () => void
  orderNo: string
  trackingNumber?: string
  isPublicDelivery?: boolean
  isCod?: boolean
  paymentStatus: string
} & ReduxProps

const OrderLogsDrawer = (props: Props) => {
  const {
    isShow,
    onClose,
    event,
    list,
    currentUser,
    orderNo,
    isPublicDelivery = false,
    trackingNumber = '',
    isCod = false,
    paymentStatus,
  } = props

  const dispatch = useDispatch()
  let isFoundCancel = false

  const onGetDataList = (): void => {
    const req: LogsReq = {
      order_no: orderNo,
      merchant_id: currentUser?.activeMerchant?.id || 0,
    }
    dispatch(getOrderLogsAPI(req, currentUser.accessToken))
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
      isFoundCancel = false
    }
  }, [isShow, orderNo])

  const findStatus = (status: string) => {
    let hasStatus = false
    let isCancel = false
    let message = ''
    let date = ''
    const result = list?.find((item: LogsData) => (item?.note?.en).toLowerCase().includes(status))
    if (status === 'payment success' && isCod) {
      hasStatus = true
      message = `เก็บเงินปลายทาง (${paymentStatus ? formatStatusPayment(paymentStatus || '') : ''})`
      date = ''
    }
    if (result) {
      hasStatus = true
      message = result?.note?.th
      date = result?.created_at
    }

    if (!result && !isFoundCancel) {
      const cancelResult = list?.find((item: LogsData) =>
        (item?.note?.en).toLowerCase().includes('has cancel your order'),
      )

      if (cancelResult) {
        hasStatus = false
        message = `${cancelResult?.note?.th} ${
          cancelResult?.reason ? `เนื่องจาก : ${cancelResult?.reason} ` : ''
        }`
        date = cancelResult?.created_at
        isFoundCancel = true
        isCancel = true
      }
    }

    return {
      hasStatus,
      message,
      date,
      isCancel,
    }
  }

  const getLogsTimeLines = () => {
    const foundCreditTerm = findStatus('credit term has been paid')?.hasStatus || false
    const logsStaus = foundCreditTerm ? logsCreditTermStatus : logsOrderStatus
    return (
      <Content>
        <Timeline mode={'left'}>
          {logsStaus.map((item, index: number) => {
            const result = findStatus(item?.value)
            const isOnShipping = item?.value === 'on shipping'
            const label = result?.hasStatus ? formatDateTime(result?.date) : ''
            const showBestTracking = isPublicDelivery && isOnShipping && result.hasStatus
            const icon = result.isCancel ? <CancelDot /> : result?.hasStatus ? <CheckDot /> : <EmptyDot />
            return (
              <Timeline.Item
                key={index}
                label={<Label>{label}</Label>}
                dot={icon}
                style={{ minHeight: '100px' }}
              >
                <Status>{item.name}</Status>
                <Label>{result?.message}</Label>
                {showBestTracking && (
                  <Label>
                    <a href={`https://www.best-inc.co.th/track?bills=${trackingNumber}`} target="_bank">
                      <Link>ตรวจสอบสถานะการจัดส่ง</Link>
                    </a>
                  </Label>
                )}
              </Timeline.Item>
            )
          })}
        </Timeline>
      </Content>
    )
  }

  return (
    <DetailDrawer
      title={'สถานะคำสั่งซื้อ'}
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={null}
      maskClosable={true}
    >
      <LoadingView isShow={event.IsLoading} />
      <Row>
        <Col md={20} xs={24}>
          {list && list.length > 0 ? getLogsTimeLines() : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const Status = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  margin-left: 10px;
`

const Content = styled.div`
  margin-top: 20px;
`

const Label = styled.div`
  padding-right: 20px;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  margin-left: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const EmptyDot = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const CheckDot = styled(CheckCircleFilled)`
  font-size: 40px;
`

const CancelDot = styled(CloseCircleFilled)`
  font-size: 40px;
`

const Link = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectLogsEvent(state),
    list: selectLogs(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(OrderLogsDrawer)
